/**
 * Created by jv on 16/02/2017.
 */
const utils = require("Sources/utils/utils");
const Dialog = require("Sources/utils/modal");

require("Styles/components/alerter.scss");

module.exports = class Alerter
{
  constructor(options)
  {
    /*
        __          _______ _____
       \ \        / /_   _|  __ \
        \ \  /\  / /  | | | |__) |
         \ \/  \/ /   | | |  ___/
          \  /\  /   _| |_| |
           \/  \/   |_____|_|

     * type (dialog | banner | notification | ... )
     * level (info | warning | error)
     *
     * title (for type dialog [required] and banner [not required])
     * text
     *
     * dismissible (for type dialog and banner)
     * dismissWait (time before alert disappears, 0 for never)
     */

    if(utils.isNull(options) && utils.isObject(options))
    {
      throw "options must be defined";
    }

    this.type = options.type;
    this.level = utils.isNullOrEmpty(options.level) ? "info" : options.level;

    this.appendTo = options.appendTo;
    this.insertAfter = options.insertAfter;
    // this.prependTo = utils.isNotNull(options.appendTo) ? options.appendTo : $("body .page-wrapper > .container");
    this.prependTo = options.appendTo;

    this.title = options.title;
    this.text = options.text;

    this.dismissible = utils.isBoolean(options.dismissible) ? options.dismissible : true;
    this.dismissWait = utils.isNumber(options.dismissWait) ? options.dismissWait : 0; // time it takes before auto dismiss (0 for don't auto dismiss (default))

    this.fullWidth = utils.isBoolean(options.fullWidth) ? options.fullWidth : false;

    this.alertEl = null;

    this.onDismiss = options.onDismiss;

    this.createAlertEl();
  }

  createAlertEl()
  {
    if(this._initialized !== true)
    {
      switch(this.type)
      {
        case "dialog":
          this.createAlertDialog();
          break;
        case "banner":
          this.createAlertBanner();
          break;
        default:
          throw "Invalid alert type";
      }
    }
  }

  createAlertDialog()
  {
    throw "NYI";

    if(this._initialized !== true && this.type === "dialog")
    {

      this._initialized = true;
    }
  }

  createAlertBanner()
  {
    if(this._initialized !== true && this.type === "banner")
    {
      this.alertEl = $("<div class='alert alert-banner'></div>").addClass(this.level);

      var alertWrapper = $("<div class='alert-wrapper'></div>");

      if(this.fullWidth)
      {
        alertWrapper.addClass("full-width");
      }

      alertWrapper.append("<div class='alert-content'>" + this.text + "</div>");

      if(this.dismissible)
      {
        var that = this;
        var closeBtn = $("<button class='btn btn-icon frameless cross-circle white alert-dismiss' type='button'></button>");
        closeBtn.on("click", function(e)
        {
          that.dismiss();
        });
        alertWrapper.append(closeBtn);
      }

      this.alertEl.append(alertWrapper);

      if(utils.isNotNull(this.appendTo))
      {
        this.appendTo.append(this.alertEl);
      }
      else if(utils.isNotNull(this.prependTo))
      {
        this.prependTo.prepend(this.alertEl);
      }
      else if(utils.isNotNull(this.insertAfter))
      {
        this.alertEl.insertAfter(this.insertAfter);
      }

      this.show();

      this._initialized = true;
    }
  }

  show()
  {
    this.alertEl.show();

    if(this.dismissWait > 0)
    {
      var that = this;

      setTimeout(function()
      {
        that.dismiss();
      }, that.dismissWait);
    }
  }

  dismiss()
  {
    if(utils.isNotNull(this.alertEl))
    {
      this.alertEl.remove();
    }

    if(utils.isFunction(this.onDismiss))
    {
      this.onDismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/components/alerter.js